import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Button, Form, Table, Modal } from 'react-bootstrap';
import appConstants from '../constants/appConstants';
import Layout from '../components/Layout';

const ListTransactions = () => {
  const [transactions, setTransactions] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadPayments();
  }, []);

  useEffect(() => {}, [transactions]);

  const loadPayments = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `https://ilmcampus.in/portal/phpscripts/get-receipts.php`,
        {
          start_date: '2024-04-01',
          end_date: '2025-03-31',
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('authToken')}`,
          },
        },
      );

      if (response.data?.status == 'success') {
        setTransactions(response.data.data);
      } else {
      }
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <>Loading...</>;
  }

  return (
    <>
      {transactions?.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Sl</th>
              <th>Date</th>
              <th>Paid To</th>
              <th>Paid By</th>
              <th>Remark</th>
              <th>amount</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((item, index) => (
              <tr key={index + 1}>
                <td>{index + 1}</td>
                <td>{item.dt}</td>
                <td>{item.paid_ledger_name}</td>
                <td>{item.ledger_name}</td>
                <td>{item.remark}</td>
                <td>{item.amount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default ListTransactions;
